import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/iot-new/banner_iot.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>IoT Development Services</h1>
              <p>
                As a forward-thinking startup or enterprise, working on IoT
                technology is a wise move. With our IoT development services,
                you can consider us as a dependable tech partner you can count
                on. We assist in creating smart gadgets, digitizing analog
                products, and developing infrastructure for bespoke IoT
                solutions. If you're aiming for a comprehensive business
                transformation, our IoT consulting strategists can smoothly
                guide you through the process.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Connect Now for Details
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
